import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import loc from '../../utils/loc';

import { Twitter, Facebook, Linkedin, Whatsapp } from '../icons';
import IconButton from '../IconButton';

const Share = ({ message, url }) => {

  /**
   * Shares message on social media in a new window
   *
   * @param {string} target - Social media target
   */
  const share = (target) => {
    const targets = {
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(message)}&url=${encodeURIComponent(url)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(message)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(`${message} ${url}`)}`
    };

    window.open(targets[target], '', 'toolbar=0, status=0, width=700, height=450');
  }

  return (
    <Wrapper>
      <Title>{loc.t('share')}</Title>
      <List>
        <li><IconButton onClick={() => share('twitter')} title="Twitter" aria-label="Twitter"><Twitter aria-hidden="true" focusable="false" /></IconButton></li>
        <li><IconButton onClick={() => share('facebook')} title="Facebook" aria-label="Facebook"><Facebook aria-hidden="true" focusable="false" /></IconButton></li>
        <li><IconButton onClick={() => share('linkedin')} title="LinkedIn" aria-label="LinkedIn"><Linkedin aria-hidden="true" focusable="false" /></IconButton></li>
        <li><IconButton onClick={() => share('whatsapp')} title="WhatsApp" aria-label="WhatsApp"><Whatsapp aria-hidden="true" focusable="false" /></IconButton></li>
      </List>
    </Wrapper>
  );
};

Share.propTypes = {
  message: PropTypes.string,
  url: PropTypes.string,
};

const Wrapper = styled.div`
  margin: 40px 0 0 0;
`;

const Title = styled.p`
  margin: 0 0 20px 0;
`;

const List = styled.ul`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export default Share;
